//module
import React, { Component } from "react";
import Edotensei from "edotensei";
import propTypes from "prop-types";
import axios from "axios";
import dateFormat from "dateformat";

//component
import Navbar from "./Include/dashboard-navbar";
import Sidebar from "./Include/dashboard-sidebar";

//scripts
const Scripts = [
  {
    src: "/scripts/jquery-2.2.0.min.js",
    rel: "preload"
  },
  {
    src: "/scripts/mmenu.min.js",
    defer: true
  },
  {
    src: "/scripts/chosen.min.js",
    defer: true
  },
  {
    src: "/scripts/slick.min.js",
    defer: true
  },
  {
    src: "/scripts/rangeslider.min.js",
    defer: true
  },
  {
    src: "/scripts/magnific-popup.min.js",
    defer: true
  },
  {
    src: "/scripts/waypoints.min.js",
    defer: true
  },
  {
    src: "/scripts/counterup.min.js",
    defer: true
  },
  {
    src: "/scripts/tooltips.min.js",
    defer: true
  },
  {
    src: "/scripts/custom.js",
    defer: true
  }
];

//get session
const session = JSON.parse(localStorage.getItem("token"));

class nilaiUjian extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nilaiUjian: [],
      nilaiUjians: [],
      isLoaded: false,

      //pagination
      currentPage: 1,
      todosPerPage: 5
    };
  }

  componentDidMount() {
    Edotensei.add(Scripts);
  }

  // handle search
  searchHandler(e) {
    //get paket
    var nilaiUjian = this.state.nilaiUjians;
    try {
      //update state
      this.setState({ currentPage: 1 });

      //filter
      nilaiUjian = nilaiUjian.filter(item => {
        //join
        var joinItem = item.nama_paket;

        //search
        return (
          joinItem.toLowerCase().search(e.target.value.toLowerCase()) !== -1
        );
      });

      //update state
      this.setState({ nilaiUjian });
    } catch (error) {
      alert(error);
    }
  }

  // async component
  async componentWillMount() {
    try {
      //get data
      let [result] = await Promise.all([
        axios.get(process.env.REACT_APP_API + "/nilai-ujian/" + session.token)
      ]);

      //update state
      this.setState({
        nilaiUjian: result.data.data,
        nilaiUjians: result.data.data,
        isLoaded: true
      });
    } catch (error) {
      throw error;
    }
  }

  render() {
    const { nilaiUjian, currentPage, todosPerPage } = this.state;

    // Logic for displaying current todos
    const indexOfLastTodo = currentPage * todosPerPage;
    const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
    const currentTodos = nilaiUjian.slice(indexOfFirstTodo, indexOfLastTodo);

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(nilaiUjian.length / todosPerPage); i++) {
      pageNumbers.push(i);
    }

    return (
      <div>
        <div hidden={this.state.isLoaded}>
          <center>
            <div style={{ marginTop: "20%" }} className="lds-facebook">
              <div />
              <div />
              <div />
            </div>
          </center>
        </div>
        <div hidden={!this.state.isLoaded}>
          {/** navbar */}
          <Navbar level={this.props.userLevel} />

          <div id="dashboard">
            {/** sidebar */}
            <Sidebar level={this.props.userLevel} />

            {/** content / overview */}
            <div className="dashboard-content">
              <div className="row">
                <div className="col-md-12">
                  <div className="dashboard-list-box margin-top-0">
                    <h4 className="clearfix" style={{ position: "relative" }}>
                      <i
                        style={{ top: "43%", position: "absolute" }}
                        className="fa  fa-search"
                      />
                      <input
                        style={{
                          marginBottom: "0",
                          borderColor: "transparent",
                          // borderBottom: "1px solid #dbdbdb",
                          boxShadow: "none"
                        }}
                        type="text"
                        className="input-text"
                        name="email"
                        placeholder="cari berdasarkan paket"
                        autoComplete="off"
                        onChange={this.searchHandler.bind(this)}
                      />
                    </h4>
                    <table className="basic-table">
                      <thead>
                        <tr>
                          <th
                            style={{
                              background: "white",
                              color: "#333"
                            }}
                          >
                            Paket
                          </th>
                          <th
                            style={{
                              background: "white",
                              color: "#333"
                            }}
                          >
                            Nilai
                          </th>
                          <th
                            style={{
                              background: "white",
                              color: "#333"
                            }}
                          >
                            Skor Akhir
                          </th>
                          <th
                            style={{
                              background: "white",
                              color: "#333"
                            }}
                          >
                            Tanggal
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentTodos.map((item, i) => (
                          <tr key={i}>
                            <td>{item.nama_paket}</td>
                            <td width="30%">
                              {item.ujian.map((ujian, x) =>
                                ujian.jumlah_skor >= ujian.standar_kelulusan ? (
                                  <a
                                    key={x}
                                    style={{
                                      borderRadius: "10px",
                                      background: "#00bfa5",
                                      color: "white",
                                      borderColor: "#00bfa5",
                                      cursor: "default",
                                      fontFamily: "Open Sans"
                                    }}
                                    href="#!"
                                    className="button border"
                                  >
                                    {ujian.nama_ujian +
                                      " : " +
                                      ujian.jumlah_skor}
                                  </a>
                                ) : (
                                  <a
                                    key={x}
                                    style={{
                                      borderRadius: "10px",
                                      background: "#2a2a2a",
                                      color: "white",
                                      borderColor: "#2a2a2a",
                                      cursor: "default",
                                      fontFamily: "Open Sans"
                                    }}
                                    href="#!"
                                    className="button border"
                                  >
                                    {ujian.nama_ujian +
                                      " : " +
                                      ujian.jumlah_skor}
                                  </a>
                                )
                              )}
                            </td>
                            <td>
                              <a
                                className="button border"
                                href="#!"
                                style={{
                                  float: "left",
                                  borderRadius: "10px",
                                  backgroundColor: "#fafafa",
                                  borderColor: "#ddd",
                                  color: "#333",
                                  fontFamily: "Open Sans"
                                }}
                              >
                                {item.skor_akhir}
                              </a>
                            </td>
                            <td>
                              <strong style={{ fontFamily: "Open Sans" }}>
                                {dateFormat(
                                  item.timestamp,
                                  "d mmm, h:M TT (yyyy)"
                                )}
                              </strong>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="pagination-container margin-top-30 margin-bottom-0">
                <nav className="pagination">
                  <ul>
                    {pageNumbers.map(number => (
                      <li key={number}>
                        <a
                          href="#!"
                          id={number}
                          className={
                            currentPage === number ? "current-page" : ""
                          }
                          onClick={e => {
                            e.preventDefault();
                            //scroll up
                            document.body.scrollTop = 0;
                            document.documentElement.scrollTop = 0;

                            //update state
                            this.setState({
                              currentPage: Number(e.target.id)
                            });
                          }}
                        >
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>

              <div className="col-md-12">
                <div className="copyrights">
                  © PT. KERJA BARENGAN MENGINOVASI PENDIDIKAN, ALL RIGHTS RESERVED.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

nilaiUjian.propTypes = {
  userLevel: propTypes.number.isRequired
};

export default nilaiUjian;
